export enum HoursMutations {
  RESET = "RESET",
  SET_HOURS = "SET_HOURS",
  SET_COURSE_HOURS = "SET_COURSE_HOURS",
}
